export const MAX_AUTO_QUALITY = {
  AUTO: 'auto',
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
} as const
export type MAX_AUTO_QUALITY =
  (typeof MAX_AUTO_QUALITY)[keyof typeof MAX_AUTO_QUALITY]
